import { useQuery } from '@tanstack/react-query';
import { checkIfEmployeeIsManagerOfManagerApi } from 'api/employee';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

const getData = async (loggedInEmployeeId, employeeId) => {
  try {
    const { entity } = await checkIfEmployeeIsManagerOfManagerApi(loggedInEmployeeId, employeeId);
    return entity;
  } catch (error) {
    console.error('Error fetching employee viewer relationship api data: ', error);
  }
};

export const useGetEmployeeViewerRelationshipData = ({ loggedInEmployeeId, employeeId }) =>
  useQuery([REACT_QUERY_KEYS.employeeIsManagerOfManager, loggedInEmployeeId], () =>
    getData(loggedInEmployeeId, employeeId)
  );
